export const monthNamesShort = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const toDate = (day: number, month: number, year: number) => {
  return new Date(Date.UTC(year, month - 1, day));
};

export function isValidPick(value: number, min?: number, max?: number) {
  const isNotValid = (min && min > value) || (max && max < value);
  return !isNotValid;
}
export const isValidMonth = (
  year: number,
  month: number,
  minDate?: Date,
  maxDate?: Date,
) => {
  if (year === minDate?.getFullYear()) {
    return minDate.getMonth() < month;
  }

  if (year === maxDate?.getFullYear()) {
    return maxDate.getMonth() + 1 >= month;
  }

  return true;
};

export const isValidYear = (year: number, minDate?: Date, maxDate?: Date) => {
  return isValidPick(year, minDate?.getFullYear(), maxDate?.getFullYear());
};

export const weekdayNamesShort = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
